import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_templatesplugin2d362b00_5da6a36c from 'nuxt_plugin_templatesplugin2d362b00_5da6a36c' // Source: ./templates.plugin.2d362b00.js (mode: 'client')
import nuxt_plugin_bootstrapvue_9671b3a0 from 'nuxt_plugin_bootstrapvue_9671b3a0' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_sentryserver_7fa007c5 from 'nuxt_plugin_sentryserver_7fa007c5' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_19e6963d from 'nuxt_plugin_sentryclient_19e6963d' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_templatesplugin7f2b3030_54de7d78 from 'nuxt_plugin_templatesplugin7f2b3030_54de7d78' // Source: ./templates.plugin.7f2b3030.js (mode: 'client')
import nuxt_plugin_recaptcha_15ce0220 from 'nuxt_plugin_recaptcha_15ce0220' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_6beaed0c from 'nuxt_plugin_vuesocialsharingplugin_6beaed0c' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_70b752ae from 'nuxt_plugin_cookieuniversalnuxt_70b752ae' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_2e5a4dfe from 'nuxt_plugin_axios_2e5a4dfe' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_templatespluginca1386fc_d4772294 from 'nuxt_plugin_templatespluginca1386fc_d4772294' // Source: ./templates.plugin.ca1386fc.js (mode: 'all')
import nuxt_plugin_plugin_32e10baf from 'nuxt_plugin_plugin_32e10baf' // Source: ./locale/plugin.js (mode: 'all')
import nuxt_plugin_whatwgfetch_4e28f3a0 from 'nuxt_plugin_whatwgfetch_4e28f3a0' // Source: ./nuxt-polyfill/whatwg-fetch.js (mode: 'all')
import nuxt_plugin_smoothscrollpolyfill_7ce4c92c from 'nuxt_plugin_smoothscrollpolyfill_7ce4c92c' // Source: ./nuxt-polyfill/smoothscroll-polyfill.js (mode: 'all')
import nuxt_plugin_objectfromentries_c54691ac from 'nuxt_plugin_objectfromentries_c54691ac' // Source: ./nuxt-polyfill/object.fromentries.js (mode: 'all')
import nuxt_plugin_intersectionobserver_079e9fd3 from 'nuxt_plugin_intersectionobserver_079e9fd3' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_loadingattributepolyfill_81639e60 from 'nuxt_plugin_loadingattributepolyfill_81639e60' // Source: ./nuxt-polyfill/loading-attribute-polyfill.js (mode: 'all')
import nuxt_plugin_urlpolyfill_6fb24674 from 'nuxt_plugin_urlpolyfill_6fb24674' // Source: ./nuxt-polyfill/url-polyfill.js (mode: 'all')
import nuxt_plugin_arrayflatpolyfill_2ebf001e from 'nuxt_plugin_arrayflatpolyfill_2ebf001e' // Source: ./nuxt-polyfill/array-flat-polyfill.js (mode: 'all')
import nuxt_plugin_requestidlecallbackpolyfill_1c47bfad from 'nuxt_plugin_requestidlecallbackpolyfill_1c47bfad' // Source: ./nuxt-polyfill/requestidlecallback-polyfill.js (mode: 'all')
import nuxt_plugin_gtm_2bf027d2 from 'nuxt_plugin_gtm_2bf027d2' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookies_1f907659 from 'nuxt_plugin_cookies_1f907659' // Source: ../plugins/cookies (mode: 'all')
import nuxt_plugin_router_3e5c7b82 from 'nuxt_plugin_router_3e5c7b82' // Source: ../plugins/router (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_init_6a81d586 from 'nuxt_plugin_init_6a81d586' // Source: ../plugins/init (mode: 'client')
import nuxt_plugin_authfix_48640fe6 from 'nuxt_plugin_authfix_48640fe6' // Source: ../plugins/auth-fix (mode: 'client')
import nuxt_plugin_device_6f3d6d68 from 'nuxt_plugin_device_6f3d6d68' // Source: ../plugins/device (mode: 'client')
import nuxt_plugin_navigation_0d3c6bec from 'nuxt_plugin_navigation_0d3c6bec' // Source: ../plugins/navigation (mode: 'client')
import nuxt_plugin_locale_52e78d60 from 'nuxt_plugin_locale_52e78d60' // Source: ../plugins/locale (mode: 'all')
import nuxt_plugin_routemeta_84016a02 from 'nuxt_plugin_routemeta_84016a02' // Source: ../plugins/route-meta (mode: 'client')
import nuxt_plugin_security_2ba9bcb6 from 'nuxt_plugin_security_2ba9bcb6' // Source: ../plugins/security (mode: 'client')
import nuxt_plugin_fontawesome_52c67aac from 'nuxt_plugin_fontawesome_52c67aac' // Source: ../plugins/library/fontawesome (mode: 'all')
import nuxt_plugin_trustpilot_6e6e032a from 'nuxt_plugin_trustpilot_6e6e032a' // Source: ../plugins/library/trustpilot (mode: 'all')
import nuxt_plugin_currency_15633587 from 'nuxt_plugin_currency_15633587' // Source: ../plugins/currency (mode: 'all')
import nuxt_plugin_brand_35502c5e from 'nuxt_plugin_brand_35502c5e' // Source: ../plugins/brand (mode: 'all')
import nuxt_plugin_category_13cbfb18 from 'nuxt_plugin_category_13cbfb18' // Source: ../plugins/category (mode: 'all')
import nuxt_plugin_product_5745fe8e from 'nuxt_plugin_product_5745fe8e' // Source: ../plugins/product (mode: 'all')
import nuxt_plugin_cart_6a7eeb96 from 'nuxt_plugin_cart_6a7eeb96' // Source: ../plugins/cart (mode: 'all')
import nuxt_plugin_redirect_7657855c from 'nuxt_plugin_redirect_7657855c' // Source: ../plugins/redirect (mode: 'client')
import nuxt_plugin_search_3c1edec4 from 'nuxt_plugin_search_3c1edec4' // Source: ../plugins/search (mode: 'all')
import nuxt_plugin_session_5d1fb660 from 'nuxt_plugin_session_5d1fb660' // Source: ../plugins/session (mode: 'all')
import nuxt_plugin_fingerprint_6f1927ae from 'nuxt_plugin_fingerprint_6f1927ae' // Source: ../plugins/fingerprint (mode: 'client')
import nuxt_plugin_modal_341cce12 from 'nuxt_plugin_modal_341cce12' // Source: ../plugins/modal (mode: 'client')
import nuxt_plugin_breadcrumb_675a200e from 'nuxt_plugin_breadcrumb_675a200e' // Source: ../plugins/breadcrumb (mode: 'client')
import nuxt_plugin_validation_f079ef22 from 'nuxt_plugin_validation_f079ef22' // Source: ../plugins/validation (mode: 'all')
import nuxt_plugin_ui_5d03b6ec from 'nuxt_plugin_ui_5d03b6ec' // Source: ../plugins/ui (mode: 'client')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a' // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_cms_5e462a13 from 'nuxt_plugin_cms_5e462a13' // Source: ../plugins/cms (mode: 'client')
import nuxt_plugin_analytics_0ae804d0 from 'nuxt_plugin_analytics_0ae804d0' // Source: ../plugins/analytics (mode: 'client')
import nuxt_plugin_sift_0c3f3e24 from 'nuxt_plugin_sift_0c3f3e24' // Source: ../plugins/library/sift (mode: 'client')
import nuxt_plugin_plugin_c68d3d06 from 'nuxt_plugin_plugin_c68d3d06' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"","meta":[{"charset":"utf-8"},{"name":"viewport","content":"user-scalable=no, width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"http-equiv":"Content-Security-Policy","content":"\n                    default-src 'self' *.dundle.dev dundle.dev *.dundle.com dundle.com localhost localhost:3002 localhost:3000 *.dinrex.com staging-dundle-api-premium.azurewebsites.net *.dundle-api.com *.fptls3.com *.fptls.com *.openfpcdn.io *.doubleclick.net *.google-analytics.com googleadservices.com *.googleadservices.com *.googlesyndication.com *.googletagmanager.com googletagmanager.com *.bing.com *.clarity.ms sentry.io *.facebook.com *.instagram.com *.braintreegateway.com *.braintree-api.com paypal.com *.paypal.com translate.google.com recaptcha.net *.recaptcha.net *.analytics.google.com *.google.com *.google.ad *.google.ae *.google.com.af *.google.com.ag *.google.com.ai *.google.al *.google.am *.google.co.ao *.google.com.ar *.google.as *.google.at *.google.com.au *.google.az *.google.ba *.google.com.bd *.google.be *.google.bf *.google.bg *.google.com.bh *.google.bi *.google.bj *.google.com.bn *.google.com.bo *.google.com.br *.google.bs *.google.bt *.google.co.bw *.google.by *.google.com.bz *.google.ca *.google.cd *.google.cf *.google.cg *.google.ch *.google.ci *.google.co.ck *.google.cl *.google.cm *.google.cn *.google.com.co *.google.co.cr *.google.com.cu *.google.cv *.google.com.cy *.google.cz *.google.de *.google.dj *.google.dk *.google.dm *.google.com.do *.google.dz *.google.com.ec *.google.ee *.google.com.eg *.google.es *.google.com.et *.google.fi *.google.com.fj *.google.fm *.google.fr *.google.ga *.google.ge *.google.gg *.google.com.gh *.google.com.gi *.google.gl *.google.gm *.google.gr *.google.com.gt *.google.gy *.google.com.hk *.google.hn *.google.hr *.google.ht *.google.hu *.google.co.id *.google.ie *.google.co.il *.google.im *.google.co.in *.google.iq *.google.is *.google.it *.google.je *.google.com.jm *.google.jo *.google.co.jp *.google.co.ke *.google.com.kh *.google.ki *.google.kg *.google.co.kr *.google.com.kw *.google.kz *.google.la *.google.com.lb *.google.li *.google.lk *.google.co.ls *.google.lt *.google.lu *.google.lv *.google.com.ly *.google.co.ma *.google.md *.google.me *.google.mg *.google.mk *.google.ml *.google.com.mm *.google.mn *.google.ms *.google.com.mt *.google.mu *.google.mv *.google.mw *.google.com.mx *.google.com.my *.google.co.mz *.google.com.na *.google.com.ng *.google.com.ni *.google.ne *.google.nl *.google.no *.google.com.np *.google.nr *.google.nu *.google.co.nz *.google.com.om *.google.com.pa *.google.com.pe *.google.com.pg *.google.com.ph *.google.com.pk *.google.pl *.google.pn *.google.com.pr *.google.ps *.google.pt *.google.com.py *.google.com.qa *.google.ro *.google.ru *.google.rw *.google.com.sa *.google.com.sb *.google.sc *.google.se *.google.com.sg *.google.sh *.google.si *.google.sk *.google.com.sl *.google.sn *.google.so *.google.sm *.google.sr *.google.st *.google.com.sv *.google.td *.google.tg *.google.co.th *.google.com.tj *.google.tl *.google.tm *.google.tn *.google.to *.google.com.tr *.google.tt *.google.com.tw *.google.co.tz *.google.com.ua *.google.co.ug *.google.co.uk *.google.com.uy *.google.co.uz *.google.com.vc *.google.co.ve *.google.vg *.google.co.vi *.google.com.vn *.google.vu *.google.ws *.google.rs *.google.co.za *.google.co.zm *.google.co.zw *.google.cat cookielaw.org *.cookielaw.org *.onetrust.com consent.cookiebot.com *.cookiebot.com *.matomo.cloud cdn.matomo.cloud consent.cookiebot.com *.cookiebot.com consent.cookiebot.eu *.cookiebot.eu *.matomo.cloud cdn.matomo.cloud rkkck31tec.execute-api.eu-central-1.amazonaws.com get.geojs.io bat.bing.net chat-assets.frontapp.com chat.frontapp.com us-west-1-chat-server.frontapp.com us-west-2-chat-server.frontapp.com eu-west-1-chat-server.frontapp.com wss:\u002F\u002Ffront-us-realtime.ably.io wss:\u002F\u002Ffront-eu-realtime.ably.io https:\u002F\u002Fchat-webhook.frontapp.com *.bugsnag.com https:\u002F\u002F*.browser-intake-datadoghq.com; \n                    img-src 'self' blob: data: * chat.frontapp.com chat-assets.frontusercontent.com;\n                    font-src 'self' blob: data: *;\n                    frame-src *.dundle.com *.paypalobjects.com *.paypal.com paypal.com *.facebook.com facebook.com youtube.com *.youtube.com youtu.be *.youtu.be *.googlesyndication.com *.doubleclick.net recaptcha.net *.recaptcha.net consent.cookiebot.com consentcdn.cookiebot.com *.cookiebot.com consent.cookiebot.eu consentcdn.cookiebot.eu *.cookiebot.eu https:\u002F\u002Fconsentcdn.cookiebot.com https:\u002F\u002Fconsentcdn.cookiebot.eu https:\u002F\u002Fwww.googletagmanager.com;\n                    style-src 'self' 'unsafe-inline' * blob:; \n                    script-src 'self' 'unsafe-inline' 'unsafe-eval' *.dundle.dev dundle.dev *.dundle.com dundle.com localhost *.google-analytics.com https:\u002F\u002Fwww.googletagmanager.com *.googletagmanager.com googletagmanager.com *.googleoptimize.com *.doubleclick.net *.google.com googleadservices.com *.googleadservices.com *.googlesyndication.com gstatic.com *.gstatic.com sentry.io *.sentry-cdn.com fpnpmcdn.net *.fptls.com *.fptls3.com *.openfpcdn.io cdn.siftscience.com *.facebook.net *.facebook.com *.facebook.com hexagon-analytics.com *.bing.com *.clarity.ms *.braintreegateway.com *.braintree-api.com paypal.com *.paypal.com www.paypalobjects.com recaptcha.net *.recaptcha.net d5yoctgpv4cpx.cloudfront.net *.sift.com\u002Fs.js cookielaw.org *.cookielaw.org *.matomo.cloud cdn.matomo.cloud consent.cookiebot.com *.cookiebot.com consent.cookiebot.eu *.cookiebot.eu chat-assets.frontapp.com chat.frontapp.com us-west-1-chat-server.frontapp.com us-west-2-chat-server.frontapp.com eu-west-1-chat-server.frontapp.com wss:\u002F\u002Ffront-us-realtime.ably.io wss:\u002F\u002Ffront-eu-realtime.ably.io https:\u002F\u002Fchat-webhook.frontapp.com *.bugsnag.com https:\u002F\u002F*.browser-intake-datadoghq.com;\n                    script-src-elem 'self' 'unsafe-inline' 'unsafe-eval' *.dundle.dev dundle.dev *.dundle.com dundle.com localhost *.google-analytics.com https:\u002F\u002Fwww.googletagmanager.com *.googletagmanager.com googletagmanager.com *.googleoptimize.com *.doubleclick.net *.google.com googleadservices.com *.googleadservices.com *.googlesyndication.com gstatic.com *.gstatic.com sentry.io *.sentry-cdn.com fpnpmcdn.net *.fptls.com *.fptls3.com *.openfpcdn.io cdn.siftscience.com *.facebook.net *.facebook.com *.facebook.com hexagon-analytics.com *.bing.com *.clarity.ms *.braintreegateway.com *.braintree-api.com paypal.com *.paypal.com www.paypalobjects.com recaptcha.net *.recaptcha.net d5yoctgpv4cpx.cloudfront.net *.sift.com\u002Fs.js cookielaw.org *.cookielaw.org *.matomo.cloud cdn.matomo.cloud consent.cookiebot.com *.cookiebot.com consent.cookiebot.eu *.cookiebot.eu chat-assets.frontapp.com chat.frontapp.com us-west-1-chat-server.frontapp.com us-west-2-chat-server.frontapp.com eu-west-1-chat-server.frontapp.com wss:\u002F\u002Ffront-us-realtime.ably.io wss:\u002F\u002Ffront-eu-realtime.ably.io https:\u002F\u002Fchat-webhook.frontapp.com *.bugsnag.com https:\u002F\u002F*.browser-intake-datadoghq.com;\n                    form-action *;\n                "},{"hid":"description","name":"description","content":""},{"hid":"theme-android","name":"theme-color","content":"#007CE1"},{"hid":"fullscreen-ios","name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"theme-ios","name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"hid":"robots","name":"robots","content":"noindex, nofollow"},{"name":"robots","content":"max-image-preview:large"},{"name":"og:image","content":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fopen-graph\u002Fdefault.png"},{"name":"image","property":"og:image","content":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fopen-graph\u002Fdefault.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fopen-graph\u002Fdefault.png"}],"link":[{"hid":"canonical","rel":"canonical","href":"\u002F"},{"hid":"favicon","rel":"icon","type":"image\u002Fx-icon","url":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fstatic\u002Ficon-2023\u002Ffavicon.ico"},{"hid":"favicon","rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fstatic\u002Ficon-2023\u002Ffavicon-16.png","sizes":"16x16"},{"hid":"favicon","rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fstatic\u002Ficon-2023\u002Ffavicon-32.png","sizes":"32x32"},{"hid":"favicon","rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fstatic\u002Ficon-2023\u002Ffavicon-512.png","sizes":"512x512"},{"hid":"favicon","rel":"apple-touch-icon","type":"image\u002Fpng","href":"https:\u002F\u002Fcdn.dundle.com\u002Fresources\u002Fimages\u002Fstatic\u002Ficon-2023\u002Ffavicon-180.png","sizes":"180X180"},{"hid":"manifest","rel":"manifest","href":"\u002Fmanifest.webmanifest","crossorigin":"use-credentials"},{"hid":"manifest","rel":"manifest","href":"\u002Fmanifest-dundle.webmanifest","crossorigin":"use-credentials"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.dundle.com","crossorigin":"use-credentials"},{"rel":"preconnect","href":"https:\u002F\u002Fimages.dundle.com","crossorigin":"use-credentials"}],"script":[{"src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js","id":"Cookiebot","data-document-language":"true","type":"text\u002Fjavascript","charset":"UTF-8","async":true,"defer":true,"data-cbid":"42418282-cb5b-4029-af0b-7001468f0728"},{"hid":"gtm","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_templatesplugin2d362b00_5da6a36c === 'function') {
    await nuxt_plugin_templatesplugin2d362b00_5da6a36c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_9671b3a0 === 'function') {
    await nuxt_plugin_bootstrapvue_9671b3a0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_7fa007c5 === 'function') {
    await nuxt_plugin_sentryserver_7fa007c5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_19e6963d === 'function') {
    await nuxt_plugin_sentryclient_19e6963d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin7f2b3030_54de7d78 === 'function') {
    await nuxt_plugin_templatesplugin7f2b3030_54de7d78(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_15ce0220 === 'function') {
    await nuxt_plugin_recaptcha_15ce0220(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_6beaed0c === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_6beaed0c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_70b752ae === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_70b752ae(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e5a4dfe === 'function') {
    await nuxt_plugin_axios_2e5a4dfe(app.context, inject)
  }

  if (typeof nuxt_plugin_templatespluginca1386fc_d4772294 === 'function') {
    await nuxt_plugin_templatespluginca1386fc_d4772294(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_32e10baf === 'function') {
    await nuxt_plugin_plugin_32e10baf(app.context, inject)
  }

  if (typeof nuxt_plugin_whatwgfetch_4e28f3a0 === 'function') {
    await nuxt_plugin_whatwgfetch_4e28f3a0(app.context, inject)
  }

  if (typeof nuxt_plugin_smoothscrollpolyfill_7ce4c92c === 'function') {
    await nuxt_plugin_smoothscrollpolyfill_7ce4c92c(app.context, inject)
  }

  if (typeof nuxt_plugin_objectfromentries_c54691ac === 'function') {
    await nuxt_plugin_objectfromentries_c54691ac(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_079e9fd3 === 'function') {
    await nuxt_plugin_intersectionobserver_079e9fd3(app.context, inject)
  }

  if (typeof nuxt_plugin_loadingattributepolyfill_81639e60 === 'function') {
    await nuxt_plugin_loadingattributepolyfill_81639e60(app.context, inject)
  }

  if (typeof nuxt_plugin_urlpolyfill_6fb24674 === 'function') {
    await nuxt_plugin_urlpolyfill_6fb24674(app.context, inject)
  }

  if (typeof nuxt_plugin_arrayflatpolyfill_2ebf001e === 'function') {
    await nuxt_plugin_arrayflatpolyfill_2ebf001e(app.context, inject)
  }

  if (typeof nuxt_plugin_requestidlecallbackpolyfill_1c47bfad === 'function') {
    await nuxt_plugin_requestidlecallbackpolyfill_1c47bfad(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2bf027d2 === 'function') {
    await nuxt_plugin_gtm_2bf027d2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookies_1f907659 === 'function') {
    await nuxt_plugin_cookies_1f907659(app.context, inject)
  }

  if (typeof nuxt_plugin_router_3e5c7b82 === 'function') {
    await nuxt_plugin_router_3e5c7b82(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_init_6a81d586 === 'function') {
    await nuxt_plugin_init_6a81d586(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authfix_48640fe6 === 'function') {
    await nuxt_plugin_authfix_48640fe6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_device_6f3d6d68 === 'function') {
    await nuxt_plugin_device_6f3d6d68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_navigation_0d3c6bec === 'function') {
    await nuxt_plugin_navigation_0d3c6bec(app.context, inject)
  }

  if (typeof nuxt_plugin_locale_52e78d60 === 'function') {
    await nuxt_plugin_locale_52e78d60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routemeta_84016a02 === 'function') {
    await nuxt_plugin_routemeta_84016a02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_security_2ba9bcb6 === 'function') {
    await nuxt_plugin_security_2ba9bcb6(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_52c67aac === 'function') {
    await nuxt_plugin_fontawesome_52c67aac(app.context, inject)
  }

  if (typeof nuxt_plugin_trustpilot_6e6e032a === 'function') {
    await nuxt_plugin_trustpilot_6e6e032a(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_15633587 === 'function') {
    await nuxt_plugin_currency_15633587(app.context, inject)
  }

  if (typeof nuxt_plugin_brand_35502c5e === 'function') {
    await nuxt_plugin_brand_35502c5e(app.context, inject)
  }

  if (typeof nuxt_plugin_category_13cbfb18 === 'function') {
    await nuxt_plugin_category_13cbfb18(app.context, inject)
  }

  if (typeof nuxt_plugin_product_5745fe8e === 'function') {
    await nuxt_plugin_product_5745fe8e(app.context, inject)
  }

  if (typeof nuxt_plugin_cart_6a7eeb96 === 'function') {
    await nuxt_plugin_cart_6a7eeb96(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_redirect_7657855c === 'function') {
    await nuxt_plugin_redirect_7657855c(app.context, inject)
  }

  if (typeof nuxt_plugin_search_3c1edec4 === 'function') {
    await nuxt_plugin_search_3c1edec4(app.context, inject)
  }

  if (typeof nuxt_plugin_session_5d1fb660 === 'function') {
    await nuxt_plugin_session_5d1fb660(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fingerprint_6f1927ae === 'function') {
    await nuxt_plugin_fingerprint_6f1927ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_341cce12 === 'function') {
    await nuxt_plugin_modal_341cce12(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_breadcrumb_675a200e === 'function') {
    await nuxt_plugin_breadcrumb_675a200e(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_f079ef22 === 'function') {
    await nuxt_plugin_validation_f079ef22(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ui_5d03b6ec === 'function') {
    await nuxt_plugin_ui_5d03b6ec(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3336a20a === 'function') {
    await nuxt_plugin_utils_3336a20a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cms_5e462a13 === 'function') {
    await nuxt_plugin_cms_5e462a13(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_0ae804d0 === 'function') {
    await nuxt_plugin_analytics_0ae804d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sift_0c3f3e24 === 'function') {
    await nuxt_plugin_sift_0c3f3e24(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_c68d3d06 === 'function') {
    await nuxt_plugin_plugin_c68d3d06(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
